import { render } from "./ProdCaracter.vue?vue&type=template&id=5a6aa6ec&scoped=true"
import script from "./ProdCaracter.vue?vue&type=script&lang=js"
export * from "./ProdCaracter.vue?vue&type=script&lang=js"

import "./ProdCaracter.vue?vue&type=style&index=0&id=5a6aa6ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6aa6ec"]])

export default __exports__